import {Component, OnInit, Inject} from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import {
    FormControl,
    FormGroup,
    FormGroupDirective,
    NgForm,
} from "@angular/forms";
import {CommentService} from "src/app/services/comment.service";
import {Comment} from "src/app/entities/comment";
import {ToastrService} from "ngx-toastr";
import {ErrorStateMatcher} from "@angular/material/core";
import {Overlay} from '@angular/cdk/overlay';

@Component({
    selector: "app-comment",
    templateUrl: "./comment.component.html",
    styleUrls: ["./comment.component.css"],
})
export class CommentComponent implements OnInit {
    totalComments = 0;
    comments: Comment[];
    content: string;
    proposalId = this.data.proposalId;
    matcher = new MyErrorStateMatcher();
    commentText = new FormControl("");
    formGroup = new FormGroup({commentText: this.commentText});
    comment: Comment;
    showShortComment = false;
    disable: boolean;

    constructor(
        private commentService: CommentService,
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<CommentComponent>,
        private overlay: Overlay,
        @Inject(MAT_DIALOG_DATA) public data: CommentComponent
    ) {
    }

    getProposalComments() {
        this.commentService.getProposalComments(this.proposalId).subscribe(
            (data) => {
                this.content = data;
                this.comments = this.sortByCreatedAt(JSON.parse(this.content).comments);
                this.totalComments = this.comments?.length;
                if (this.totalComments === 0) {
                    this.dialogRef.updateSize("600px", "450px");
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    alterCommentText() {
        this.showShortComment = !this.showShortComment;
    }

    ngOnInit(): void {
        this.getProposalComments();
        this.dialogRef.updateSize("800px", "700px");
    }

    onSubmit() {
        this.matcher.submited = true;
        if (this.formGroup.invalid) {
            return;
        }
        this.disable = true;

        this.transformToComment();
        this.commentService.addComment(this.comment).subscribe(
            (data) => {
                this.toastr.success("Comentario creado");
                this.commentText.setValue("");
                this.commentText.markAsPending();
                this.getProposalComments();
                this.disable = false;
            },
            (error) => {
                console.error(error);
                this.disable = false;
            }
        );
    }

    transformToComment() {
        this.comment = new Comment();
        this.comment.comment = this.formGroup.get("commentText").value;
        this.comment.proposalId = this.proposalId;
        this.comment.userId = 0;
    }

    onClose() {
        this.dialogRef.close({
            event: "close",
            data: this.comments ? this.comments.length : 0,
        });
    }

    sortByCreatedAt(comments: Comment[]) {
        console.log(comments)
        return comments.sort((a, b) => (a.createdAt < b.createdAt) ? 1 : -1);
    }

}


export class MyErrorStateMatcher implements ErrorStateMatcher {
    submited = false;

    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean {
        const isSubmitted = this.submited;
        return !!(control && control.invalid && isSubmitted);
    }
}